<template>
  <el-dialog
    title="创建盘点"
    :visible="true"
    :before-close="onCloseDialog"
    width="800px"
  >
    <el-form>
      <el-form-item label="盘点类型">
        <el-select
          v-model="form.inventory_type"
          placeholder="盘点类型"
          filterable
          style="width: 250px"
        >
          <el-option
            v-for="item in resData.inventory_type"
            :key="item.key"
            :label="item.label"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="盘点方式">
        <el-select
          v-model="form.inventory_model"
          placeholder="盘点方式"
          filterable
          style="width: 250px"
        >
          <el-option
            v-for="item in resData.inventory_model"
            :key="item.key"
            :label="item.label"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="盘点仓区">
        <el-select
          v-model="form.area_type"
          placeholder="盘点仓区"
          filterable
          style="width: 250px"
        >
          <el-option
            v-for="item in resData.area_type"
            :key="item.key"
            :label="item.label"
            :value="item.key"
          ></el-option>
        </el-select>
        <el-select
          v-model="form.areas"
          placeholder="盘点仓区"
          filterable
          multiple
          style="width: 150px"
          @change="getTunnels"
        >
          <el-option
            v-for="item in resData.areas"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        <el-select
          v-model="form.space_type"
          placeholder="盘点仓位"
          filterable
          style=""
        >
          <el-option
            v-for="item in resData.inventory_space_type"
            :key="item.key"
            :label="item.label"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="盘点巷道">
        <el-row
          v-for="(tunnel, key) in tunnels"
          :key="key"
          type="flex"
          style="margin-left: 80px;margin-top: 10px"
        >
          <el-col :span="1">{{ tunnel.area }}:</el-col>
          <el-col :span="5">
            <el-select v-model="form.tunnels[key].min" size="small">
              <el-option
                v-for="(value, value_key) in tunnel.tunnels"
                :key="value_key"
                :value="value"
                :label="value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="1" style="margin-left: 15px">至</el-col>
          <el-col :span="5">
            <el-select v-model="form.tunnels[key].max" size="small">
              <el-option
                v-for="(value, value_key) in tunnel.tunnels"
                :key="value_key"
                :value="value"
                :label="value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="备注说明">
        <el-input v-model="form.remark" placeholder="remark"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onCloseDialog">取 消</el-button>
      <el-button type="primary" @click="createInventory">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      resData: {},
      loading: false,
      url: "/erp/Inventory/getCondition",
      form: {
        tunnels: [],
      },
      tunnels: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$http
        .post(this.url)
        .then(result => {
          this.loading = false;
          if (result.data.code != 200) {
            return this.$message.error(result.data.msg);
          }
          this.$set(this, "resData", result.data.data);
        })
        .catch(err => {
          this.loading = false;
          this.onCloseDialog();
          return this.$message.error("数据获取失败");
        });
    },
    createInventory() {
      this.$http
        .post("/erp/Inventory/createInventory", this.form)
        .then(result => {
          this.loading = false;
          if (result.data.code != 200) {
            return this.$message.error(result.data.msg);
          }
          this.onCloseDialog();
          return this.$message.success(result.data.msg);
        })
        .catch(err => {
          this.loading = false;
          return this.$message.error("数据获取失败");
        });
    },
    getTunnels() {
      if (!this.form.areas) {
        return false;
      }
      this.$http
        .post("/erp/Inventory/getAreaTunnels", {
          area: this.form.areas,
        })
        .then(res => {
          if (res.data.code == 200) {
            this.tunnels = res.data.data;
            this.form.tunnels = [];
            this.tunnels.forEach((item, key) => {
              this.form.tunnels.push({
                area: item.area,
                min: item.tunnels[0],
                max: item.tunnels[item.tunnels.length - 1],
              });
            });
          }
          return true;
        });
    },
    onCloseDialog() {
      this.$emit("onCloseDialog", false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/inventory/components/CreateInventory.vue